export default (oldObject, newValues) => ({ ...oldObject, ...newValues })
